<template>
  <div class="page-content page-content">
    <h1 class="page-title">{{  $locale('sideMenu.settings.payment') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button class="egl-btn-gray" disabled v-if='getApproveItem().length === 0'>{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="approve_fn" v-else>{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="createAction">{{
          $locale("global.create")
        }}</el-button>
      </el-col>
    </el-row>

    <List :tableHeaderData="tableHeaderData" :tableData="paymentList" name="payment" :isShowChange="true" />
    <CommPagination
      :total="pageCount"
      :curPage="currentPage"
      @current-change="pageChange"
    />

    <div v-if="this.dialogVisible">
    <Dialog
      :closeAction="closeEditDialog"
      :visible="dialogVisible"
      :confirmAction="submitPaymentForm"
      :titleText="$locale('setting.pay.edit.title')"
      width=""
    >
      <el-form ref="form" :model="paymentDetailData" :disabled="!isEdit" :rules="formRules">
        <!-- master description -->
        <div>
        <el-form-item :label="$locale('global.name')" prop="name">
          <el-input
            :placeholder="$locale('form.plsEnterYourName')"
            v-model="paymentDetailData.name"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$locale('setting.pay.nameshow')" prop="nameShow">
          <el-input
            :placeholder="$locale('setting.pay.p.nameshow')"
            v-model="paymentDetailData.nameShow"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$locale('global.sort')" prop="sortOrder">
          <el-input
            :placeholder="$locale('setting.pay.p.nameshow')"
            v-model="paymentDetailData.sortOrder"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$locale('setting.pay.paygroup')" prop="type">
          <el-select
            :placeholder="$locale('setting.pay.p.paygroup')"
            v-model="paymentDetailData.type"
            @change="val => changeType(val)"
          >
            <el-option value="cash" :label="$locale('setting.pay.type.cash')"></el-option>
            <el-option value="creditCard" :label="$locale('setting.pay.type.creditCard')"></el-option>
            <el-option value="gmo" :label="$locale('setting.pay.type.gmo')"></el-option>
            <el-option value="cash380" :label="$locale('setting.pay.type.cash380')"></el-option>
            <el-option value="creditCard3000" :label="$locale('setting.pay.type.creditCard3000')"></el-option>
            <el-option value="payPay" label="paypay"></el-option>
            <el-option value="creditCardA920" label="クレジット（A920)"></el-option>
            <el-option value="paypayA920" label="paypay（A920)"></el-option>
            <el-option value="creditCardA35" label="クレジット（A35)"></el-option>
            <el-option value="paypayA35" label="paypay（A35)"></el-option>
            <el-option value="paypayGmo" label="paypay（GMO)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="paymentDetailData.type === 'creditCard'" :label="$locale('setting.pay.paygroup') + '2'" prop="type2" :rules="type2Rules">
          <el-select
            :placeholder="$locale('setting.pay.p.paygroup')"
            v-model="paymentDetailData.type2"
          >
            <el-option
              v-for="_type in Object.entries(type2Mapping)"
              :key="_type[0]"
              :value="_type[0]"
              :label="_type[1]"
            ></el-option>
          </el-select>
        </el-form-item>
        </div>
      </el-form>
      <div v-if="showOptions">
        <div class="parting-line">&nbsp;</div>
        <FeeSetting ref="feeset" :title="selectedOpt" :key="selectedOpt" :cl="cl" :jl="jl" :fixMethod="fixMethod" :cardInfo="cardInfo"
        :isUpdate="isUpdate"
        :isOpen="dialogVisible"
        @setChange="handleSetChange" @entry1='handleEntry1' @entry2='handleEntry2'/> 
        <!-- 売上処理料 setting -->
        <div class="parting-line">&nbsp;</div>
        <el-form ref="salespro" :model="processFee">
          <el-row :gutter="10">
            <el-col :span="20">
                
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.process.fee') }}</span>
                    <el-input v-model="processFee.amount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item >
                    <span slot="label"><img /></span>
                    <el-select v-model="processFee.unit" >
                      <el-option
                        v-for="item in unitIndex"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.process.transmethod') }}</span>
                    <template v-if="this.fixMethod">
                    <el-select v-model="processFee.method" disabled>
                      <el-option
                        v-for="item in modidx"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                    </template>
                    <template v-else>
                    <el-select v-model="processFee.method" >
                      <el-option
                        v-for="item in modidx"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item>
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.process.tax') }}</span> 
                    <TaxSelect v-model="processFee.taxRate"></TaxSelect>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="14">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.process.client') }}</span>
                    <!-- <el-select v-model="processFee.client" filterable>
                      <el-option 
                        v-for="item in cl"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select> -->
                    <remote-select
                      type="client"
                      :isMultiple="false"
                      v-model="processFee.client"
                      :formValue.sync="processFee.client"
                      :actionType="!isUpdate ? 'create' : 'edit'"
                    ></remote-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.account')">
                    <el-select v-model="processFee.bookEntrySales">
                      <el-option v-for="n in jl"
                      :key="n.id"
                      :value="n.id"
                      :label="n.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.entry1')">
                    <el-input v-model="processFee.entry1Sales" placeholder="A123"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.entry2')">
                    <el-input v-model="processFee.entry2Sales" placeholder="A123"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-col>
          </el-row>
          <!-- System fee setting -->
          <div class="parting-line">&nbsp;</div>
          <el-row :gutter="10">
            <el-col :span="20">
                  
              <el-row :gutter="10">
                <el-col :span="14">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.system.fee') }}</span>
                    <el-input v-model="processFee.systemFee" @input.native="handleSysFee"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.system.tax') }}</span>
                    <TaxSelect v-model="processFee.systemTax"></TaxSelect>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item >
                    <span slot="label" class="one-line-label">{{ $locale('setting.pay.system.client') }}</span>
                    <!-- <el-input v-model="processFee.systemClient" /> -->
                    <!-- <el-select v-model="processFee.systemClient">
                      <el-option 
                        v-for="item in cl"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select> -->
                    <remote-select
                      type="client"
                      :isMultiple="false"
                      v-model="processFee.systemClient"
                      :formValue.sync="processFee.systemClient"
                      :actionType="!isUpdate ? 'create' : 'edit'"
                    ></remote-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.account')">
                    <el-select v-model="processFee.bookEntrySys">
                      <el-option v-for="n in jl"
                      :key="n.id"
                      :value="n.id"
                      :label="n.name"
                      ></el-option>
                    </el-select>                    
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.entry1')">
                    <el-input v-model="processFee.entry1Sys" placeholder="A123"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.entry2')">
                    <el-input v-model="processFee.entry2Sys" placeholder="A123"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-col>
          </el-row>
        </el-form>
        <!-- GMO special setting -->
        <el-form ref="gmopro" :model="gmospec">
          <template v-if="selectedOpt == 'gmo' || selectedOpt == 'paypayGmo'">
          <div class='parting-line'>&nbsp;</div>
          <el-row :gutter="10">
            <el-col >
              <p class="p-cust" :style="{'display':'inline'}">{{ $locale('setting.pay.gmospec') }}</p>&nbsp;&nbsp;
              <el-tooltip :content="$locale('setting.pay.gmospec.tooltip')" placement="right-end" effect='light'>
                <i class="el-icon-question" />
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="20">
              <el-form-item :label="$locale('setting.pay.gmospec.id')">
                <el-input v-model="gmospec.id"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="20">
              <el-form-item :label="$locale('setting.pay.gmospec.auth')">
                <el-input v-model="gmospec.auth"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </template>
        </el-form>

        <div class="parting-line">&nbsp;</div>
        <el-row :gutter="10" class="makeBottomMargin">
          <el-col >
            <p class="p-cust" :style="{'display':'inline'}">{{ $locale('bookKeeping.journal') }}</p>&nbsp;&nbsp;
            <el-tooltip :content="''" placement="right-end" effect='light'>
              <i class="el-icon-question" />
            </el-tooltip>
          </el-col>
        </el-row>
        <div v-for="i in journal.length" :key="i">
        <el-form :ref="'journal'+i" :model="journal[i-1]">
          <p class="p-cust makeBottomMargin" :style="{'display':'inline'}">{{ $locale('global.settlement') }}{{ i }}</p>
          <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.account')">
              <el-select v-model="journal[i-1].bookEntry">
                <el-option v-for="n in jl"
                :key="n.id"
                :value="n.id"
                :label="n.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.entry1')">
              <el-input v-model="journal[i-1].entry1" placeholder="A123"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.entry2')">
              <el-input v-model="journal[i-1].entry2" placeholder="A123"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
       </el-form>
        </div> 
      </div>
      
      <div class="parting-line" v-if="!paymentDetailData.isApprove">&nbsp;</div>
      <el-form ref="releasepro" :model="paymentDetailData">
        <ApproveField v-if="!paymentDetailData.isApprove" v-model="paymentDetailData.reflectDate" :formData="paymentDetailData" fieldName="reflectDate" />
      </el-form>
    </Dialog>
    </div>
  </div>
</template>
<style scoped>
.makeBottomMargin {
  margin-bottom: 10px;
}
</style>

<script>
// const cinemaId = window.localStorage.getItem("cinemaId");
// let cinemaId;
import "@/assets/style/paymentManagement.less";
import List from "@/components/Version/list.vue";
import Dialog from "@/components/Version/dialog.vue";
import CommPagination from "@/components/common/CommPagination";
import FeeSetting from "@/components/Settings/FeeSetting.vue"
import {
  getPaymentListService,
  // getPaymenTypesService,
  addPaymentService,
  updatePaymentService,
  delPaymentService,
  // getPaymentDetailService,
  // getPaymentNameListService,
  PaymentServiceDetail,
  PaymentApproveService,
} from "@/helpers/service/api/payment";
import { getAccountListService } from "@/helpers/service/api/accounting";
import { getClientListService } from "@/helpers/service/api/common";
import ApproveField from "@/components/common/ApproveField";
import countDownAlert from "@/utils/countDownAlert";
import TaxSelect from "@/components/common/TaxSelect";
import RemoteSelect from "@/components/common/RemoteSelect";

export default {
  components: {
    List,
    Dialog,
    CommPagination,
    ApproveField,
    FeeSetting,
    TaxSelect,
    RemoteSelect,
  },

  data() {
    return {
      // Fix values
      paymentNameList:  {
        "cash": this.$locale('setting.pay.type.cash'),
        "creditCard": this.$locale('setting.pay.type.creditCard'),
        "gmo" : this.$locale('setting.pay.type.gmo'),
        "cash380" : this.$locale('setting.pay.type.cash380'),
        "creditCard3000" : this.$locale('setting.pay.type.creditCard3000'),
        "payPay":"paypay",
        "creditCardA920":"クレジット（A920)",
        "paypayA920":"paypay（A920)",
        "creditCardA35":"クレジット（A35)",
        "paypayA35":"paypay（A35)",
        "paypayGmo":"paypay（GMO)",
      },
      unitIndex: [
        {
          label: "%",
          value: 'percent'
        },
        {
          label: this.$locale('global.yen.text'),
          value: 'yen'
        },
      ],
      modidx : [
        {
          label: this.$locale('setting.pay.mod.single'),
          value: 'single',
        },
        {
          label: this.$locale('setting.pay.mod.month'),
          value: 'month',
        }
      ],
      cl: {},
      jl: [],
      fixMethod : false,
      showOptions: false,
      selectedOpt: "",
      cinemaId: "",
      dialogVisible: false,
      paymentDetailData: {
        name: "",
        nameShow: "",
        type: "",
        type2: "",
        sortOrder: 0,
        isApprove: "",
        reflectDate: this.$moment().startOf("day").valueOf(),
        status : "active",
      },
      cardInfo: [],
      processFee: {
        amount : 0,
        unit : 'percent',
        method: 'single',
        taxRate: 0.1,
        client:'',
        systemFee:0,
        systemTax: 0.1,
        systemClient: '',
        bookEntrySales: '',
        entry1Sales: '',
        entry2Sales: '',
        bookEntrySys: '',
        entry1Sys: '',
        entry2Sys: '',
      },
      gmospec : {
        id: '',
        auth:'',
      },
      journal: [],
      isEdit: true,
      tableHeaderData: [
        { prop: "name", label: this.$locale("global.name") },
        { prop: "nameShow", label: this.$locale("setting.pay.nameshow") },
        { prop: "typeText", label: this.$locale("setting.pay.paygroup") },
        {
          prop: "type2",
          label: this.$locale("setting.pay.paygroup") + "2",
          formatter: (row, column, cellValue, index) => {
            return this.type2Mapping[cellValue] || cellValue;
          },
        },
      ],
      paymentList: [],
      pageCount: 0,
      currentPage: 0,
      isUpdate: false,
      notApprove: [],
      id: '',
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        nameShow: [ {
          required: true,
          message: this.$locale("setting.pay.p.nameshow"),
          trigger: "blur",
        } ],
        type: [{
          required: true,
          message: this.$locale("setting.pay.p.paygroup"),
          trigger: "change",
        }],
      },
      type2Mapping: {
        creditCard: this.$locale("setting.pay.typ2.option1"),
        goodCoupon: this.$locale("setting.pay.typ2.option2"),
        mobilePay: this.$locale("setting.pay.typ2.option3"),
      },
      type2Rules: [ {
        required: true,
        message: this.$locale("setting.pay.p.paygroup"),
        trigger: "change",
      } ],
    };
  },

  mounted() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    
    if (!this.cinemaId) {
      this.$emit("callCinema", "getPaymentList");
      return;
    }
    this.getPaymentList();
    // this.getClients();

    let payload = {
      brandId: window.localStorage.getItem('brandId'),
      forPos : true,
      pageSize: 9999,
      page: 0,
    }
    getAccountListService(payload).then( res => {
      let ls = res.data.data
      this.jl = ls
    })    

  },

  methods: {
    handleEntry1(idx,val) {
      this.journal[idx].entry1 = val
    },
    handleEntry2(idx,val) {
      this.journal[idx].entry2 = val
    },
    handleSetChange(total, idx) {
      if(total > this.journal.length) {
        this.journal.push({
          bookEntry:'',
          entry1:'',
          entry2:'',
        })
      } else {
        this.journal.splice(idx, 1);
      } 
    },
    handleSysFee(e) {
      let val = e.target.value
      val = this.handleRe1KSeperator(val)
      e.target.value =  this.handle1KSeperator(val)
    },

    handle1KSeperator(val) {
      let regex = /\B(?=(\d{3})+(?!\d))/g
      return val.toString().replace(regex,',')
    },

    handleRe1KSeperator(val) {
      let regex = /,/g
      return val.toString().replace(regex,'')
    },
    
    getApproveItem() {
      let approveArr = [];
      let { paymentList } = this;
      for (let i = 0; i < paymentList.length; i++) {
        if (!paymentList[i].isApprove) {
          approveArr.push(paymentList[i].id);
        }
      }
      return approveArr;
    },
    delPaymentItem(pid) {
      if (!pid) { return; }

      delPaymentService({ id: pid }).then(() => {
        countDownAlert({
          content: this.$locale("global.deleteSuccessfully"),
          callback: () => {
            this.getPaymentList();
          }
        });
      });
    },

    getPaymentList() {
      getPaymentListService({
        cinemaId: this.cinemaId,
        page: this.currentPage,
      }).then(res => {
        let paylist = res.data.data
        this.paymentList = []
        paylist.map(item => {
          this.paymentList.push( {
            ...item,
            typeText:this.paymentNameList[item.type],
          })
        })
        this.pageCount = res.data.count;
      });
    },

    getClients() {
      getClientListService({
        page: 0,
        pageSize: 10000,
        field: ["id", "name", "clientCode", "groupName", "aliasName"]
      }).then( res => {
        this.cl = res.data.data
      })
    },

    // getPaymentTypes() {
    //   let hash = window.localStorage.getItem("dictionary")
    //   hash = JSON.parse(hash);
    //   let data = hash.payment.PaymentType
    //   this.paymentNameList = []
    //   Object.keys( data).map(key => {
    //     if(key != 'none') {
    //       this.paymentNameList.push(key)
    //     }
    //   })
    // },
    
    pageChange(value) {
      if (!value) { return; }

      this.currentPage = value - 1;
      this.getPaymentList();
    },
    createAction() {
      this.cardInfo = []
      this.isUpdate = false;
      this.journal = []
      this.openDialog();
    },
    editAction(context) {
      this.openDialog();
      PaymentServiceDetail(context).then(res => {
        this.paymentDetailData = res.data
        let served = res.data
        this.id = context.id
        this.cinemaId = context.cinemaId
        this.paymentDetailData = {
          ...res.data
        }
        this.changeType(served.type) 
        this.isEdit = served.edit;
        this.isUpdate = true;
        
        this.processFee = served.transFee
        //Special handle to systemFee
        this.processFee.systemFee = this.handle1KSeperator(served.transFee.systemFee)
        this.cardInfo = served.cardFee
        this.gmospec = served.gmospec
        this.journal = served.journal 

        // this.paymentDetailData = res.data;
      });
      // this.paymentDetailData = { ...context };
    },
    delAction(context) {
      let confirmHtml =
        `<i class="egl-confirm-question">?</i><span class="result-text">
          ${context.name} ${this.$locale("version.screen.action.del")}
        </span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          this.delPaymentItem(context.id);
        });
    },

    submitPaymentForm() {
      const that = this
      let cardFees = (that.$refs.feeset) ? that.$refs.feeset.returnData(): []
      const requestParam = {
        ...this.paymentDetailData,
        transFee: {
          amount: (parseFloat(this.processFee.amount) == NaN) ? 0:parseFloat(this.processFee.amount),
          method: this.processFee.method,
          unit: this.processFee.unit,
          taxRate: this.processFee.taxRate,
          client: this.processFee.client,
          systemFee: (parseFloat(this.handleRe1KSeperator(this.processFee.systemFee)) == NaN)? 
            0:parseFloat(this.handleRe1KSeperator(this.processFee.systemFee)),
          systemTax: this.processFee.systemTax,
          systemClient: this.processFee.systemClient,
          bookEntrySales: this.processFee.bookEntrySales,
          entry1Sales : this.processFee.entry1Sales,
          entry2Sales : this.processFee.entry2Sales,
          bookEntrySys : this.processFee.bookEntrySys,
          entry1Sys : this.processFee.entry1Sys,
          entry2Sys : this.processFee.entry2Sys,
        },
        cinemaId: this.cinemaId,
        cardFee: cardFees,
        id: this.isUpdate ? this.id : '',
        gmospec : this.gmospec,
        journal : this.journal,
        approveForPos: this.paymentDetailData.approveForPos,
        // isApprove: this.paymentDetailData.isApprove, 
      };

      if (!requestParam.type2) {
        delete requestParam.type2;
      }

      const requestScuessFn = countDownText => {
        this.closeEditDialog()
        countDownAlert({
          content: countDownText,
          callback: () => {
            this.getPaymentList();
          }
        });
      };

      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.isUpdate) {
            addPaymentService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.createSuccessfully"));
            }).catch( err => {
              console.log(err)
            });
          } else {
            updatePaymentService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          // setTimeout(() => {
          //   const isError = document.getElementsByClassName("is-error");
          //   isError[0].querySelector("input").focus();
          // }, 100);
          return false;
        }
      })


    },

    openDialog() {
      this.dialogVisible = true;
      // this.getPaymentTypes()
    },

    changeType(val) {
      this.journal = []
      if(val == 'cash' || val == 'cash380') {
        this.showOptions = false
        this.fixMethod = false 
      } else {
        this.journal.push({
            bookEntry: '',
            entry1: '',
            entry2: '' ,
        })
        this.showOptions = true
        if(val == 'gmo' || val == 'creditCard3000') {
          this.fixMethod = true
        } else {
         this.fixMethod = false 
        }
      }
      this.selectedOpt = val

      if (val !== "creditCard") {
        this.paymentDetailData.type2 = "";
      } else if (!this.paymentDetailData.type2) {
        this.paymentDetailData.type2 = "creditCard";
      }
    },

    closeEditDialog() {
      this.paymentDetailData = {
        name: "",
        nameShow:"",
        type: "",
        type2: "",
        sortOrder:0,
        reflectDate: this.$moment().startOf("day").valueOf(),
        isApprove: false,
      };
      this.processFee = {
        amount : 0,
        unit : 'percent', // percent or yen
        method: 'single', // single / moonth
        taxRate: 0.1,
        client:'',
        systemFee:0,
        systemTax: 0.1,
        systemClient: '',
      }
      // this.$refs.form.resetFieldsresetFields();
      this.gmospec = {
        id:'',
        auth:'',
      }
      this.fixMethod = false
      this.dialogVisible = false
      this.showOptions = false
      this.journal = []
    },
    approve_fn() {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
          PaymentApproveService({ cinemaId: this.cinemaId }).then(() => {
            this.getPaymentList();
            // Obsolute before 08-11
            // this.getPaymentNameMapping();
          });
        });
    },
  },
};
</script>
